const AlertMsgStyles = theme => ({
    
});

export default AlertMsgStyles;
